/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/megrez/exam';
const BaseDir = '/question-collection';

export const QuestionCollectionAPI = {
    QUESTION_COLLECTION_SUBMIT_QUESTION: {
        url: BasePath + '/v1' + BaseDir + '/submit-question',
        type: API_TYPE.POST,
    },
    QUESTION_COLLECTION_MARK_QUESTION: {
        url: BasePath + '/v1' + BaseDir + '/mark',
        type: API_TYPE.POST,
    },
    QUESTION_COLLECTION_DONE_PRACTICE: {
        url: BasePath + '/v1' + BaseDir + '/done',
        type: API_TYPE.POST,
    },
    QUESTION_COLLECTION_GET_QUESTION_ID_LIST: {
        url: BasePath + '/v1' + BaseDir + '/get-question',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_GET_QUESTION_INFO: {
        url: BasePath + '/v1' + BaseDir + '/get-question-info',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_GET_QUESTION_DESC: {
        url: BasePath + '/v1' + BaseDir + '/get-question-desc',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_GET_QUESTION_STATUS: {
        url: BasePath + '/v1' + BaseDir + '/question-status',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_GET_QUESTION_ANSWER: {
        url: BasePath + '/v1' + BaseDir + '/question-right-answer',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_GET_QUESTION_USER_ANSWER: {
        url: BasePath + '/v1' + BaseDir + '/user-answer',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_GET_QUESTION_COUNT: {
        url: BasePath + '/v1' + BaseDir + '/question-count',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_GET_ELEMENT_LIST: {
        url: BasePath + '/v1' + BaseDir + '/element-list',
        type: API_TYPE.GET,
    },
    QUESTION_COLLECTION_START_PRACTICE: {
        url: BasePath + '/v1' + BaseDir + '/start-practice',
        type: API_TYPE.GET,
    },
    // NOTES: 可以把整个小节的错题移出考题本，但不能把整个小节的题目移进考题本
    // 加入考题本
    QUESTION_COLLECTION_ADD: {
        url: BasePath + '/v1' + BaseDir + '/add',
        type: API_TYPE.POST,
    },
    // 移出考题本
    QUESTION_COLLECTION_DEL: {
        url: BasePath + '/v1' + BaseDir + '/del',
        type: API_TYPE.POST,
    },
    ENTER_EXAM: {
        url: BasePath + '/v1/enterExam',
        type: API_TYPE.POST,
    },
    START_EXAM: {
        url: BasePath + '/v1/startExam',
        type: API_TYPE.POST,
    },
};